import posthog from "posthog-js";
import api from "./services/api";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || "";
const SESSION_KEY = "icing_session_id";

// Generate or retrieve session ID
function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

// Init PostHog once
let phInited = false;
export function initAnalytics(user) {
  if (!POSTHOG_KEY || phInited) return;
  posthog.init(POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://eu.posthog.com",
    autocapture: true,
    capture_pageview: true,
    session_recording: { maskAllInputs: true },
  });
  if (user) {
    posthog.identify(String(user.id), { username: user.username, email: user.email });
  }
  phInited = true;
}

// Send event to both PostHog and our backend
export function track(eventType, data = {}) {
  // PostHog
  if (phInited) posthog.capture(eventType, data);
  // Backend
  try {
    api.post("/analytics/track/", {
      event_type: eventType,
      event_data: data,
      session_id: getSessionId(),
    }).catch(() => {});
  } catch(e) {}
}

export function trackClick(element, data = {})         { track("click",   { element, ...data }); }
export function trackView(page, data = {})             { track("view",    { page, ...data }); }
export function trackSearch(query, data = {})          { track("search",  { query, ...data }); }
export function trackWatch(videoId, duration, data={}) { track("watch",   { video_id: videoId, duration_seconds: duration, ...data }); }
export function trackSession(data = {})                { track("session", data); }

export default posthog;
